import React from "react";
import { ValType } from "../../utils/ValidationFunctions";
import Form from "../../common/forms/Form";
import FormInput from "../../common/forms/FormInput";

import RegistHeader from "./RegistHeader";

import styles from "./p-register.module.scss";
import formStyles from "../../common/forms/g-formInput.module.scss";

type Props = {
  display_name: string;
  submit_handler: () => void;
  input_handler: (value: string) => void;
  backward_handler: () => void;
};

const RegistDisplayNameForm: React.FC<Props> = ({
  display_name,
  submit_handler,
  input_handler,
  backward_handler,
}) => {
  return (
    <div className={styles["p-register__box"]}>
      <RegistHeader
        showLogo={false}
        title={"会員名の入力"}
        message={`SELeCTで使用する 会員名 を入力してください\nニックネームや会社名でも大丈夫です`}
      />
      <p className={styles["p-register__notes--account-name"]}>
        {`会員名はSELeCT上に表示される場合がございます。\n会員名は後から変更できます。`}
      </p>
      <div className={styles["p-register__form"]}>
        <Form
          handler={submit_handler}
          button_id="next_button"
          button_text="次へ"
          button_class={formStyles["g-button"]}
        >
          <div className={formStyles["g-form__wrapper"]}>
            <FormInput
              type="textBeforeLabel"
              label="名前"
              name="sonic_display_name"
              val_type={ValType.DisplayName}
              placeholder="Serena"
              id="sonic_display_name"
              handler={input_handler}
              style_class={formStyles["g-form__input"]}
              label_class={formStyles["g-form__label"]}
              initial_value={display_name}
            />
          </div>
        </Form>
        <button
          type="button"
          className={styles["p-register__form__button"]}
          onClick={backward_handler}
        >
          戻る
        </button>
      </div>
    </div>
  );
};

export default RegistDisplayNameForm;
